let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { useTheme, isDarkTheme } from 'foundations-theming/utils';
import { useIsPillBorderRadius } from '../hooks/useIsPillBorderRadius';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGlobalPopoverOverrides = createGlobalStyle(_t || (_t = _`
  [data-component-name="UIPopover"] {
    border-radius: ${0} !important;
  }
  [data-component-name="UIPopover"][data-nav-label-popover] {
    border-radius: 12px !important;
  }
  ${0}
`), ({
  $borderRadius
}) => $borderRadius, ({
  $isDarkMode,
  $bgColor,
  $textColor
}) => $isDarkMode && `
      [data-component-name="UIPopover"] {
        background-color: ${$bgColor} !important;
        color: ${$textColor} !important;
      }
      [data-floating-ui-portal] [data-component-name="UIPopover"] > svg {
        fill: ${$bgColor} !important;
      }
  `);
export const GlobalPopoverStyles = () => {
  const theme = useTheme();
  const isPill = useIsPillBorderRadius();
  const isDarkMode = isDarkTheme(theme);
  return /*#__PURE__*/_jsx(StyledGlobalPopoverOverrides, {
    $borderRadius: isPill ? theme.borderRadius['0'] : theme.borderRadius['300'],
    $isDarkMode: isDarkMode,
    $bgColor: theme.color['fill-surface-default'],
    $textColor: theme.color['text-core-default']
  });
};